<template>
  <div class="col px-0 px-md-3">
    <ColorPointsHeader :message="greenHeaderMessage" color="rgba(190, 206, 35, 0.5)" /><div class="row center">
    <div class="col-12 text-center" v-html=" focus.paragraphe1 ? focus.paragraphe1.texte : '' "></div>
    </div>
    <h2 class="row center justify-content-center text-secondary font-weight-bold pt-5" v-html=" focus.paragraphe2 ? focus.paragraphe2.titre : '' "></h2>
    <div class="row center">
      <div class="col-12 text-center" v-html=" focus.paragraphe2 ? focus.paragraphe2.texte : '' "></div>
    </div>
    <h2 class="row center justify-content-center text-secondary font-weight-bold pt-5" v-html=" focus.paragraphe3 ? focus.paragraphe3.titre : '' "></h2>
    <div class="row center">
      <div class="col-12 text-center" v-html=" focus.paragraphe3 ? focus.paragraphe3.texte : '' "></div>
    </div>
    <h2 class="row center justify-content-center text-secondary font-weight-bold pt-5" v-html=" focus.paragraphe4 ? focus.paragraphe4.titre : '' "></h2>
    <div class="row center">
      <div class="col-12 text-center pb-5" v-html=" focus.paragraphe4 ? focus.paragraphe4.texte : '' "></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { getFocus } from '../../../mixins/getFocus'

export default {
  name: 'FinancementImmobilier',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../../components/ColorPointsHeader')
  },
  data () {
    return {
      greenHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      temoignages: {},
      focus: []
    }
  },
  async beforeMount () {
    await this.getFocus('CG Courtage', 'Financement immobilier et professionnels')
      .then(res => {
        console.log(res)
        this.focus = res
        this.greenHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
      })
  }
}
</script>
